export const createDatadogError = (errorName: string, errorMessagePrefix?: string) => {
    class CustomDatadogNamedError extends Error {
        type = `${errorName}Error`;
        constructor(errorMessage: string) {
            const prefixedMessage = errorMessagePrefix ? `${errorMessagePrefix} ${errorMessage}` : `${errorMessage}`;
            super(prefixedMessage);
            this.type = `${errorName}Error`;
            this.name = `${errorName}Error`;
            this.message = prefixedMessage;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (this as any).__proto__ = CustomDatadogNamedError.prototype;
        }
    }
    return CustomDatadogNamedError;
};
